import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { useTranslation } from 'react-i18next';

const NotFoundPage = () => {
    const navigate = useNavigate();
    const {t} = useTranslation()
    return (
        <div className="h-screen w-full flex justify-center items-center">
            <div className="w-full md:w-[500px] h-full md:h-[600px] bg-white shadow-sm rounded-sm flex flex-col justify-center items-center p-6">
                <div className="text-2xl font-bold text-gray-800 flex items-center">
                    {t("erreur_survenue")} <span className="text-6xl">⛓️‍💥</span>
                </div>
                <div className="text-center text-gray-500 mt-10">
                   {t("erreur")} <span className="text-xl">😞</span>
                </div>
                <Button
                    className="mt-5 text-white px-3 py-2"
                    onClick={() => navigate(-1)}
                >
                    {t("back")}
                </Button>
            </div>
        </div>
    );
};

export default NotFoundPage;
